import { Bookmark, BookmarkCheck } from "lucide-react";

export default function SaveJobButton({ saved, onClick, className = "", withLabel = false, testId }) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={saved ? "Remove saved job" : "Save job"}
      data-testid={testId}
      className={`inline-flex items-center gap-2 rounded-full border px-3 py-2 text-sm font-medium transition-colors ${
        saved
          ? "border-sky-400/60 bg-sky-400/10 text-sky-300"
          : "border-white/15 bg-white/5 text-slate-200 hover:border-sky-400/50 hover:text-white"
      } ${className}`}
    >
      {saved ? <BookmarkCheck className="h-4 w-4" /> : <Bookmark className="h-4 w-4" />}
      {withLabel && (saved ? "Saved" : "Save")}
    </button>
  );
}
